import {
  Box,
  Button,
  FormControl,
  FormHelperText,
  InputLabel,
  OutlinedInput,
  TextField,
  Typography,
} from '@mui/material';
import { ChangeEvent, MouseEvent, useEffect, useState } from 'react';
import Grid from '@mui/material/Unstable_Grid2';
import { CreatePointAcumulatedType } from '@/types';
import { pointAcumulated } from '@/api/point/create';
import { toast } from 'react-toastify';
import { sleep } from '@/lib/util';
import Loading from '@/component/mui/Backdrop';

export default function RegisterAccumulated({
  settingId,
  onSuccess,
  refresh,
}: {
  settingId: string;
  onSuccess: () => void;
  refresh: number;
}) {
  const defaultItem: CreatePointAcumulatedType = {
    settingId: settingId,
    accPoint: '',
    title: '',
    describe: '',
    doneDescribe: '',
  };
  const [item, setItem] = useState<CreatePointAcumulatedType>(defaultItem);
  const [isLoading, setIsLoading] = useState(false);
  useEffect(() => {
    (async () => {
      setItem(defaultItem);
      // await readSettingAcumulatedList();
    })();
    return () => {};
  }, [refresh]);

  const handleChangeValue = (e: ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    console.log(name);
    console.log(value);
    if (!name) {
      return;
    }
    setItem((prev: CreatePointAcumulatedType) => ({
      ...prev,
      [name]: value,
    }));
  };
  const onSubmit = async (event: MouseEvent<HTMLButtonElement>) => {
    console.log(`onSubmit`);
    console.log(event);

    if (!item.accPoint) {
      return;
    }

    event.preventDefault();
    setIsLoading(true);
    try {
      const re = await pointAcumulated(item);
      if (re.status !== 200) {
        toast.error('실패');
        setIsLoading(false);
        return;
      }
      await sleep(1000);
      toast.success('성공');
      setIsLoading(false);
      onSuccess();
    } catch (e) {
      toast.error('실패');
      setIsLoading(false);
    }
  };

  return (
    <>
      <Typography variant="h6">목표 포인트 생성</Typography>
      ※ 반드시 point(목표포인트)는 오름차순으로 설정해야 합니다. <br />
      (만약 중간에 추가를 해야 할 경우 기존에 세팅되어 있는 목록에서 바꿔야 합니다.)
      <Box p={1} />
      <Grid container spacing={3}>
        <Grid md={6} xs={12}>
          <FormControl fullWidth required>
            <InputLabel>point</InputLabel>
            <OutlinedInput
              type="string"
              value={item.accPoint}
              label="accPoint"
              name="accPoint"
              onChange={handleChangeValue}
            />
            <FormHelperText>※ 목표 포인트</FormHelperText>
          </FormControl>
        </Grid>
        <Grid md={6} xs={12}>
          <FormControl fullWidth required>
            <InputLabel>Title</InputLabel>
            <OutlinedInput value={item.title} label="title" name="title" onChange={handleChangeValue} />
            <FormHelperText>※ 포인트 게임이 동일할 때 같은 코드</FormHelperText>
          </FormControl>
        </Grid>
      </Grid>
      <Box mb={2} />
      <TextField
        name="describe"
        id="describe"
        label="describe"
        multiline
        rows={1}
        value={item.describe}
        onChange={handleChangeValue}
      />
      <FormHelperText>※ [메인화면] 게이지 안내 멘트</FormHelperText>
      <Box mb={2} />
      <TextField
        name="doneDescribe"
        id="doneDescribe"
        label="doneDescribe"
        multiline
        rows={1}
        value={item.doneDescribe}
        onChange={handleChangeValue}
      />
      <FormHelperText>※ [모달] 구간 완료 시 보상 멘트</FormHelperText>
      <Box mb={5} />
      <Button fullWidth variant="contained" onClick={onSubmit}>
        생성
      </Button>
      <Loading isLoading={isLoading} />
    </>
  );
}
